import { Navigate, useLocation } from 'react-router-dom';

import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

import { PAYMENT_VIEW_ROUTE } from '../../constants';

export const CheckoutPageProtectedRoute = ({
  baseRoute,
  children,
  isAfterPaymentStep,
}) => {
  const { search } = useLocation();
  const {
    selectedPlan = {},
    setUpIntentData,
    stripeDetails,
    stripeSetUpIntent,
  } = useCheckoutContext() || {};

  const hasSelectedPlan = !!selectedPlan?.displayName;
  const hasPaymentDetails =
    !!setUpIntentData?.createSetupIntent &&
    !!stripeSetUpIntent?.payment_method &&
    !!stripeDetails?.stripePaymentMethodId;

  const displayPath = isAfterPaymentStep
    ? hasSelectedPlan && hasPaymentDetails
    : hasSelectedPlan;

  return displayPath ? (
    children
  ) : hasSelectedPlan && !hasPaymentDetails ? (
    <Navigate
      replace
      to={{
        pathname: `${baseRoute}/${PAYMENT_VIEW_ROUTE}`,
        search,
      }}
    />
  ) : (
    <Navigate replace to={{ pathname: baseRoute, search }} />
  );
};
